import React from 'react';
import { isMobile } from '@/biz/tool';
import WebModal from '../Modal';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import BottomDrawer from '../BottomDrawer';
import { useTranslation } from 'react-i18next';
import { getContents } from './config';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import { Button } from 'aha-components';

interface Props {}

const ModalEducation: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { detailData } = useDetailDataStore();

  const {
    showPromotionalLinkEducationModal,
    setShowPromotionalLinkEducationModal
  } = useWebModalStore();

  const Contents = () => {
    const contents = getContents(
      detailData?.order?.platform,
      detailData?.order?.utmLink,
      t
    );
    return (
      <div className="relative h-full w-full">
        <div className="w-full h-full mt-1 md:mt-2 md:h-[524px] overflow-y-auto pb-[56px]">
          <div className="justify-start text-[#57534D] text-sm font-normal leading-snug mb-6 md:mb-4">
            {t('ModalPromotionalLinkEducation.instructionText')}
          </div>
          <div className="flex flex-col gap-6 pl-[20px]">
            {contents.map((content, index) => (
              <ul key={content?.img} className="flex flex-col gap-3">
                <li className="justify-start list-disc pl-2">
                  {content.title}
                </li>
                <img
                  src={content?.img}
                  alt={t('ModalPromotionalLinkEducation.promotionalLinkAlt')}
                  className="h-auto"
                  style={{ width: content.width }}
                />
              </ul>
            ))}
          </div>
        </div>
        <div className="absolute left-0 bottom-0 flex items-center justify-center w-full h-[40px]">
          <Button
            type="primary"
            size="medium"
            className="w-full"
            onClick={() => {
              setShowPromotionalLinkEducationModal(false);
            }}
          >
            {t('ModalPromotionalLinkEducation.gotIt')}
          </Button>
        </div>
      </div>
    );
  };

  return (
    <>
      {isMobile() ? (
        <BottomDrawer
          isShowFooter={false}
          title={t('ModalPromotionalLinkEducation.modalTitle')}
          visible={showPromotionalLinkEducationModal}
          handleClose={() => {
            setShowPromotionalLinkEducationModal(false);
          }}
        >
          <div className={`h-[calc(100vh-140px)] bg-white`}>
            <Contents />
          </div>
        </BottomDrawer>
      ) : (
        <WebModal
          title={t('ModalPromotionalLinkEducation.modalTitle')}
          visible={showPromotionalLinkEducationModal}
          isShowFooter={false}
          width={624}
          handleClose={() => {
            setShowPromotionalLinkEducationModal(false);
          }}
          className="p-8 rounded-[16px] overflow-hidden"
        >
          <Contents />
        </WebModal>
      )}
    </>
  );
};

export default ModalEducation;
